import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { getBezierPath, BaseEdge, EdgeLabelRenderer, useReactFlow } from 'reactflow';
import { FaTimes } from 'react-icons/fa';
import './ButtonEdge.scss';
const ButtonEdge = (props) => {
    const { id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, style = {}, markerEnd } = props;
    const reactFlowInstance = useReactFlow();
    // Get a smooth Bezier path instead of a straight one
    const [edgePath, labelX, labelY] = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });
    // Function to remove the edge
    const onEdgeClick = useCallback((evt) => {
        evt.stopPropagation();
        reactFlowInstance.setEdges(reactFlowInstance.getEdges().filter((edge) => edge.id !== id));
    }, [id, reactFlowInstance]);
    return (_jsxs(_Fragment, { children: [_jsx(EdgeLabelRenderer, { children: props.data && props.data.connectionType && (_jsx("div", { style: {
                        position: 'absolute',
                        transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY - 12}px)`,
                        pointerEvents: 'none',
                        zIndex: 1,
                    }, children: _jsx("span", { className: `connection-type-badge ${props.data.connectionType}`, children: props.data.connectionType === 'nested' ? 'SEQ' : 'LINK' }) })) }), _jsx(BaseEdge, { path: edgePath, markerEnd: markerEnd, style: style }), _jsx(EdgeLabelRenderer, { children: _jsx("div", { style: {
                        position: 'absolute',
                        transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
                        pointerEvents: 'all',
                        zIndex: -1,
                    }, className: "nodrag", children: _jsx("button", { className: "edge-button", onClick: onEdgeClick, onMouseEnter: (e) => {
                            e.currentTarget.parentElement.style.zIndex = '10';
                        }, onMouseLeave: (e) => {
                            e.currentTarget.parentElement.style.zIndex = '-1';
                        }, children: _jsx(FaTimes, {}) }) }) })] }));
};
export default ButtonEdge;
